import './style.scss';

// Import utilities
import { onReady } from '@automator/utilities';

// Import classes
import ReRunItem from './re-run-item';

// Invoke classes when the DOM is ready
onReady( () => {
    new ReRunItem();
} );
